import type { TypographyColors } from '@ui/uikit/components/common/Typography';
import { Typography } from '@ui/uikit/components/common/Typography';

import type { AdjacentRound } from '../../../../../../../model/AdjacentRound/adjacentRound';
import { PredictionRoundState } from '../../../../../../../model/AdjacentRound/roundState';

type PredictionMainPriceProps = {
  round: AdjacentRound;
};

type AllowedKeys = Extract<keyof AdjacentRound, 'closePrice' | 'priceChange' | 'totalAmount'>;

type MainConfigItem = {
  priceKey: AllowedKeys;
  title: string;
  color: TypographyColors;
};

export const PredictionMainPrice = ({ round }: PredictionMainPriceProps) => {
  const MainPriceConfig: Record<PredictionRoundState, MainConfigItem> = {
    [PredictionRoundState.CLOSED]: {
      priceKey: 'closePrice',
      title: 'Closed Price',
      color: 'primary',
    },
    [PredictionRoundState.LOCKED]: {
      priceKey: 'closePrice',
      title: 'Current Price',
      color: round.priceChange.value > 0 ? 'green' : 'red',
    },
    [PredictionRoundState.ACTIVE]: {
      priceKey: 'totalAmount',
      title: 'Prize Pool',
      color: 'primary',
    },
  };

  const { priceKey, title, color } = MainPriceConfig[round.state];

  return (
    <div className="flex flex-col mb-3">
      <Typography variant="caption-s" color="tertiary" textAlign="center">
        {title}
      </Typography>
      <Typography variant="display" color={color} textAlign="center">
        {round[priceKey].formatted}
      </Typography>
    </div>
  );
};
